import {
  NotificationPlayerLevelState,
  NotificationState,
} from "@/domains/notification/constants/notificationState";

export default function isPlayerLevelNotification(
  notification: NotificationState,
): notification is NotificationPlayerLevelState {
  return (notification as NotificationPlayerLevelState).increase !== undefined;
}
